import * as React from "react";

import FilterCheckObjSimple from "../filters/FilterCheckObjSimple";
import FilterCheckObjTree from "../filters/FilterCheckObjTree";
import ModalComponent from "./ModalComponent";
import WordInsertions from "../../utils/WordInsertions";

import '../../styles/Modal.css'

/**
 * Modal for inserting loop through selected model's objects
 */
export default class ModalLoopObject extends ModalComponent
{
    /**
     * After confirm the selection, the loop is inserted into Word document
     */
    handleFilterConfirm = () =>
    {
        const aSelection = this.aFilterCheckRef.current.getSelection();
        if (0 < aSelection.length)
        {
            WordInsertions.modelObjLoop(aSelection);
            this.toggleModal();
        }
    }

    render()
    {
        this.aFilterCheckRef = React.createRef();
        const { isTree, sTitle, sConfirmLabel, sRejectLabel, aItems } = this.props;

        return (
            this.state.openModal
                ? <div className="PopupBackground">
                    <div className="PopupContent">

                        <h3 className="Modal__label">{sTitle}</h3>

                        {isTree
                            ? <FilterCheckObjTree
                                aJsonTree={aItems}
                                ref={this.aFilterCheckRef}
                            />
                            : <FilterCheckObjSimple
                                aItems={aItems}
                                ref={this.aFilterCheckRef}
                            />
                        }

                        <button className="wrcButton wrcButton--confirm" onClick={this.handleFilterConfirm}>
                            {sConfirmLabel}
                        </button>
                        <button className="wrcButton wrcButton--confirm" onClick={this.toggleModal}>
                            {sRejectLabel}
                        </button>

                    </div>
                </div>
                : null
        );
    }
}
